<template>
    <div class="header-box">
        <!-- <div class="logo-section box">
			<div class="search">
			</div>
			<div class="logo">
				<router-link to="">
					<img src="../../assets/images/logo.png" />
				</router-link>
			</div>
		</div> -->
        <div class="clear"></div>
        <div class="top-nav">
            <h2>
                <router-link to="/"><a>启帆数字</a></router-link>
            </h2>
            <nav class="nav-menu-box">
                <ul class="star-list">
                    <li>
                        <router-link to="/" @click.native="navMenuClick">网站首页</router-link>
                    </li>
                    <li>
                        <router-link to="/me" @click.native="navMenuClick">关于我们</router-link>
                    </li>
                    <template v-if="$route.path !== '/about'">
                        <li>
                            <a href="#qyfw">企业服务</a>
                        </li>
                        <li>
                            <a href="#essc">二手市场</a>
                        </li>
                        <li>
                            <a href="#jypx">休闲娱乐</a>
                        </li>
                    </template>
                    <li style="margin-left: 30px; float: right; color: #ffffff; cursor: pointer" v-if="!isLogin" @click="btnLogIn">登录</li>
                    <li style="margin-left: 30px; float: right;" v-else class="user-center-item">
                        <el-dropdown @command="handleUserCommand" trigger="click">
                            <span class="user-info-btn">
                                <i class="el-icon-user"></i>
                                用户中心
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="userInfo">个人信息</el-dropdown-item>
                                <el-dropdown-item command="publishHistory">发布记录</el-dropdown-item>
                                <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li style="float: right; color: #ffffff; cursor: pointer" @click="btnPublish">发布信息</li>
                </ul>
            </nav>
            <h2 class="m-nav-h" @click="showMobileNav">
                <span class="nav-icon"></span>
            </h2>
        </div>
        <!--登录-->
        <el-dialog title="登录" :visible.sync="dialogFormVisible" width="500px" :center="true" class="login-box">
            <el-form :model="loginForm">
                <el-form-item label="手机号">
                    <el-input v-model="loginForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="手机验证码">
                    <el-input v-model="loginForm.code" placeholder="请输入手机验证码" clearable></el-input>
                </el-form-item>
            </el-form>
            <el-button style="width: 100%" @click="btnSendCode()">发送验证码</el-button>

            <div style="margin-top: 20px">
                <el-checkbox v-model="loginForm.readFile">我已仔细阅读并同意</el-checkbox>

                <router-link class="red" to="/user-agreement" @click.native="closeLegalDialog">《用户协议》</router-link>
                &
                <router-link class="red" to="/privacy-policy" @click.native="closeLegalDialog">《隐私政策》</router-link>
            </div>
            <el-button style="width: 100%; margin-top: 40px" type="primary" @click="login">登 录</el-button>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
            </div>
        </el-dialog>
        <!-- 发布信息 -->
        <el-dialog title="发布信息" :visible.sync="dialogInfoVisible" width="520px" :center="true" class="login-box">
            <el-form :model="infoForm" ref="infoFormRef" :label-position="labelPosition" label-width="90px">
                <el-form-item label="联系人" required>
                    <el-input v-model="infoForm.zd1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" required>
                    <el-input v-model="infoForm.zd2" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="公司名字" required>
                    <el-input v-model="infoForm.zd3" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="标题" required>
                    <el-input v-model="infoForm.head" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="简介" required>
                    <el-input v-model="infoForm.desc" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="图片url" required>
                    <el-input v-model="infoForm.img" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="详情" required>
                    <el-input v-model="infoForm.detail" type="textarea" :rows="4" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="viewPublishHistory" style="float: left;">查看发布记录</el-button>
                <el-button @click="dialogInfoVisible = false">取 消</el-button>
                <el-button type="primary" @click="release">发 布</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
    name: 'Header',
    props: {},
    data() {
        return {
            dialogFormVisible: false, //登录弹框
            dialogInfoVisible: false,
            loginForm: {
                username: '',
                password: '',
                phone: '', //手机号
                code: '', //验证码
                readFile: false //是否阅读协议
            },
            infoForm: {
                zd1: '',
                zd2: '',
                zd3: '',
                head: '',
                desc: '',
                img: '',
                detail: ''
            },
            isMinScreen: this.$root.$data.isMinScreen,
            labelPosition: 'right'
        };
    },
    computed: {
        ...mapState(['isLogin'])
    },
    watch: {
        //监听是否是小窗口界面
        '$root.$data.isMinScreen': function (val) {
            if (typeof val === 'boolean') {
                this.isMinScreen = val;
            }
            //非小屏幕
            if (!val) {
                document.getElementsByClassName('nav-menu-box').item(0).style.display = 'block';
                let listSubList = document.querySelectorAll('.start-list-sub');
                listSubList.forEach(function (v) {
                    v.removeAttribute('style');
                });
            }
        }
    },
    created() {
        console.log('head created', localStorage.getItem('isLogin') || '');
        this.setIsLogin(localStorage.getItem('isLogin') || '');
        console.log(this.$route.path);
    },
    methods: {
        ...mapMutations({
            setIsLogin(commit, isLogin) {
                commit('setIsLogin', isLogin);
            }
        }),
        //点击发布
        btnPublish() {
            if (this.isLogin) {
                this.dialogFormVisible = false;
                this.dialogInfoVisible = true;
            } else {
                this.dialogFormVisible = true;
            }
        },
        //点击登录
        btnLogIn() {
            this.dialogFormVisible = true;
        },
        // 发送验证码
        btnSendCode() {
            //校验参数
            if (!this.loginForm.phone) {
                this.$message.warning('请先输入手机号');
                return;
            }
            let req = {
                timestamp: 'timestamp',
                sign: 'sign',
                smsType: 8,
                phone: this.loginForm.phone
            };
            // console.log(this.$http)
            this.$http.post(this.$apis.account.testSendSms, req).then(
                ({ code, data }) => {
                    if (code === '0000') {
                        this.$message.success('验证码发送！');
                    }
                },
                (err) => {
                    console.log(err, 'err');
                }
            );
        },
        login() {
            //校验参数
            if (!this.loginForm.phone) {
                this.$message.warning('请先输入手机号');
                return;
            }
            if (!this.loginForm.code) {
                this.$message.warning('请输入手机验证码');
                return;
            }
            if (!this.loginForm.readFile) {
                this.$message.warning('请您仔细阅读并同意用户及隐私协议');
                return;
            }
            let req = {
                timestamp: 'timestamp',
                sign: 'sign',
                appKey: 'appKey',
                phoneNumber: this.loginForm.phone,
                code: this.loginForm.code
            };
            this.$http.post(this.$apis.account.testPhoneLogin, req).then(
                ({ code, data }) => {
                    if (code === '0000') {
                        this.$message.success('登录成功！');
                        localStorage.setItem('isLogin', '1');
                        this.setIsLogin('1');
                        this.dialogFormVisible = false;
                        // this.loginForm.phone = ''
                        this.loginForm.code = '';
                    }
                },
                (err) => {
                    console.log(err, 'err');
                }
            );
        },
        btnLogOut() {
            this.isLogin = false;
            localStorage.setItem('isLogin', '');
            this.setIsLogin('');
        },
        release() {
            if (
                this.infoForm.head == '' ||
                this.infoForm.desc == '' ||
                this.infoForm.img == '' ||
                this.infoForm.detail == '' ||
                this.infoForm.zd1 == '' ||
                this.infoForm.zd2 == '' ||
                this.infoForm.zd3 == ''
            ) {
                this.$message.warning('请输入完整信息！');
            } else {
                this.$message.success('提交成功，请等待审核！');
                this.dialogInfoVisible = false;
                this.infoForm.head = '';
                this.infoForm.desc = '';
                this.infoForm.img = '';
                this.infoForm.detail = '';
                this.infoForm.zd1 = '';
                this.infoForm.zd2 = '';
                this.infoForm.zd3 = '';
            }
        },
        //小窗口菜单显示逻辑
        showMobileNav() {
            let navDom = document.getElementsByClassName('nav-menu-box').item(0);
            navDom.style.display = !navDom.style.display || navDom.style.display === 'none' ? 'block' : 'none';
        },
        subNavOpen(e) {
            let listSubList = document.querySelectorAll('.start-list-sub');
            listSubList.forEach(function (v) {
                if (v === e.currentTarget.previousElementSibling) {
                    v.style.display = v.style.display === 'block' ? 'none' : 'block';
                } else {
                    v.style.display = 'none';
                }
            });
            //document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
        },
        //菜单点击原生事件
        navMenuClick() {
            if (this.isMinScreen) {
                document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none';
            }
        },
        //搜索页面
        showSearchPage() {
            this.$router.push('/m-search');
        },
        viewPublishHistory() {
            this.dialogInfoVisible = false;
            this.$router.push('/publish-history');
        },
        handleUserCommand(command) {
            if (command === 'userInfo') {
                this.$router.push('/user-profile');
            } else if (command === 'publishHistory') {
                this.viewPublishHistory();
            } else if (command === 'logout') {
                this.btnLogOut();
            }
        },
        closeLegalDialog() {
            this.dialogFormVisible = false;
        }
    }
};
</script>
<style>
.red {
    color: #ff0000;
}

.login-box /deep/ .el-dialog {
    border-radius: 8px;
}

.login-box /deep/ .el-button--primary {
    background-color: #f76447;
    border-color: #f76447;
}

.login-box /deep/ .el-button:focus,
.login-box /deep/ .el-button:hover {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    color: #989898;
}

.login-box /deep/ .el-button--primary:focus,
.login-box /deep/ .el-button--primary:hover {
    background-color: #f74321;
    border-color: #f74321;
    color: #ffffff;
}

.user-info-btn {
    color: #ffffff;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 4px;
    transition: background-color 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    line-height: 1.5;
    font-size: 14px;
    height: auto;
}

.user-info-btn:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.user-info-btn i {
    font-size: 14px;
}


</style>
